export default {
  create: {
    title: 'Agregar',
    subtitle: 'Numerex',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Numerex',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Numerex',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Numerex',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Numerex Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    rows: {
      label: 'Filas:',
    },
    columns: {
      label: 'Columnas:',
    },
    level: {
      label: 'Nivel:',
      placeholder: 'Seleccione el nivel...',
    },
    generationMode: {
      label: 'Forma de generación:',
      placeholder: 'Seleccione la forma...',
      options: {
        simple: 'Simple',
        distribution: 'Distribución',
      },
    },
    numberLengthRange: {
      section: 'Distribución',
      min: {
        label: 'Tamaño mínimo',
        tooltip: 'Tamaño mínimo de los números generados.',
      },
      max: {
        label: 'Tamaño máximo',
        tooltip: 'Tamaño máximo de los números generados.',
      },
    },
    prioritizeQuality: {
      label: 'Priorizar calidad',
      tooltip:
        'Ejecuta intentos extra después de la generación principal para intentar mejorar el resultado. Puede tardar más.',
    },
    numbersList: {
      label: 'Lista de números:',
      copyTooltip: 'Copiar lista al portapapeles',
    },
    grid: {
      cellLabel: 'Celda fila {row}, columna {col}',
    },
  },
  sidebar: {
    exportHint: 'Necesita guardar antes de exportar.',
    defaultFileName: 'numerex',
  },
  button: {
    generate: 'Generar juego',
  },
  alert: {
    gameSaved: '¡Juego guardado con éxito!',
    cleared: '¡Cuadrícula limpiada con éxito!',
    generated: '¡Numerex generado con éxito!',
    generateFailed: 'No fue posible generar el Numerex.',
    numberLengthRangeInvalid:
      'Informe un intervalo válido de tamaño de números (mín. ≤ máx.).',
    numbersListCopied: '¡Lista de números copiada!',
    numbersListCopyFailed: 'No fue posible copiar la lista de números.',
    sendSuccess: 'Enviado con éxito',
    sendError: 'Error al enviar. Inténtelo de nuevo.',
  },
};
